// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2srii","header":"PatientBlock_header__1ljnQ","label":"PatientBlock_label__OQ4dc","option":"PatientBlock_option__1v_S8"};